module.exports = __webpack_public_path__ + "static/media/ellipsis-purple.dff6226c.gif";